import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from './components/ui/toaster';

// Pages
import Home from './pages/Home';
import BookDetail from './pages/BookDetail';
import Quiz from './pages/Quiz';
import QuizResult from './pages/QuizResult';
import SuggestBook from './pages/SuggestBook';
import RequestQuiz from './pages/RequestQuiz';
import Login from './pages/Login';
import Profile from './pages/Profile';
import Leaderboard from './pages/Leaderboard';

// Admin Pages
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminBooks from './pages/admin/AdminBooks';
import AdminQuizzes from './pages/admin/AdminQuizzes';
import AdminQuestions from './pages/admin/AdminQuestions';
import AdminUsers from './pages/admin/AdminUsers';
import AdminSuggestions from './pages/admin/AdminSuggestions';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <div className="App">
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/book/:bookId" element={<BookDetail />} />
            <Route path="/quiz/:quizId" element={<Quiz />} />
            <Route path="/quiz/:quizId/result" element={<QuizResult />} />
            <Route path="/suggest-book" element={<SuggestBook />} />
            <Route path="/request-quiz" element={<RequestQuiz />} />
            <Route path="/request-quiz/:bookId" element={<RequestQuiz />} />
            <Route path="/login" element={<Login />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/players/:playerId" element={<Profile />} />
            <Route path="/leaderboard" element={<Leaderboard />} />

            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/books" element={<AdminBooks />} />
            <Route path="/admin/quizzes" element={<AdminQuizzes />} />
            <Route path="/admin/questions/:quizId" element={<AdminQuestions />} />
            <Route path="/admin/questions" element={<AdminQuestions />} />
            <Route path="/admin/users" element={<AdminUsers />} />
            <Route path="/admin/suggestions" element={<AdminSuggestions />} />
          </Routes>
          
          <Toaster />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
